import React, { Component } from "react";
import { connect } from "react-redux";
import {
  get_jobseeker_profile,
  updateJobseekerConsent,
  checkJobseekerConsent,
} from "../../../actions/jobseekerAction";
import {
  clearConsentSession,
  markConsentCompletedThisSession,
  setConsentCheckResult,
} from "../../../consentUtils";
import store from "../../../store";

class ConsentPage extends Component {
  state = {
    submitting: false,
    checkingConsent: true,
  };

  componentDidMount() {
    document.title = "Consent Required";
    store.dispatch(get_jobseeker_profile());
    this.verifyConsentStillNeeded();
  }

  componentDidUpdate(prevProps) {
    const prevUser = prevProps.actionReducer.Loginuser;
    const currentUser = this.props.actionReducer.Loginuser;
    const prevId =
      prevUser && !Array.isArray(prevUser)
        ? prevUser.id || prevUser.user_id
        : null;
    const currentId =
      currentUser && !Array.isArray(currentUser)
        ? currentUser.id || currentUser.user_id
        : null;

    if (currentId && currentId !== prevId) {
      this.verifyConsentStillNeeded();
    }
  }

  getLocalizedPath = (path) => {
    const lang = this.props.params && this.props.params.lang;
    return lang ? `/${lang}/${path}` : `/${path}`;
  };

  redirectToMyAccount = () => {
    this.props.router.replace(this.getLocalizedPath("myaccount"));
  };

  getUserId = () => {
    const profile = this.props.JobseekerReducer.Profile || {};
    const loginuser = this.props.actionReducer.Loginuser;
    const isLoginUser =
      loginuser && typeof loginuser === "object" && !Array.isArray(loginuser);
    return (
      profile.user_id ||
      (isLoginUser && (loginuser.id || loginuser.user_id)) ||
      null
    );
  };

  verifyConsentStillNeeded = async () => {
    const userId = this.getUserId();
    if (!userId || this._verifying) return;

    this._verifying = true;
    try {
      const hasConsent = await store.dispatch(checkJobseekerConsent(userId));
      if (hasConsent) {
        this.redirectToMyAccount();
        return;
      }
      this.setState({ checkingConsent: false });
    } finally {
      this._verifying = false;
    }
  };

  submitConsent = async (consent) => {
    const userId = this.getUserId();

    if (!userId || this.state.submitting) return;

    this.setState({ submitting: true });
    const success = await store.dispatch(
      updateJobseekerConsent({
        user_id: userId,
        personal_info_sharing_consent: consent,
      })
    );

    if (success && Number(consent) === 1) {
      markConsentCompletedThisSession();
      this.redirectToMyAccount();
      return;
    }

    if (success && Number(consent) === 0) {
      setConsentCheckResult(false);
      this.setState({ submitting: false });
      return;
    }

    clearConsentSession();
    this.setState({ submitting: false });
  };

  render() {
    const userId = this.getUserId();
    const loadingProfile = !userId || this.state.checkingConsent;

    return (
      <main className="container py-5" aria-labelledby="consent-page-title">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="card shadow-sm border-0">
              <div className="card-body p-4 p-md-5">
                <h1 id="consent-page-title" className="h3 mb-3">
                  Consent Required
                </h1>

                {!loadingProfile && (
                  <>
                    <div className="text-left">
                      <p className="mb-4">
                        Your personal data is collected for the purpose of
                        providing employment-related services to you.
                      </p>
                      <p className="mb-4">
                        Please provide your consent by clicking "Yes" to allow
                        us to share your data with relevant stakeholders.
                      </p>
                      <p className="mb-4">
                        If you do not wish to share your personal data with
                        other stakeholders of the Employment Department,
                        please click "No".
                      </p>
                    </div>

                    <div className="d-flex justify-content-center gap-3">
                      <button
                        type="button"
                        className="btn btn-success px-4"
                        disabled={this.state.submitting}
                        onClick={() => this.submitConsent(1)}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger px-4"
                        disabled={this.state.submitting}
                        onClick={() => this.submitConsent(0)}
                      >
                        No
                      </button>
                    </div>
                  </>
                )}

                {loadingProfile && (
                  <p className="mb-0" role="status">
                    Loading your profile...
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(ConsentPage);
